// selectedBatchSlice.js
import { createSlice } from "@reduxjs/toolkit";

const selectedBatchSlice = createSlice({
  name: "selectedBatch",
  initialState: null,
  reducers: {
    setSelectedBatch: (state, action) => {
      return action.payload;
    },
  },
});

export const { setSelectedBatch } = selectedBatchSlice.actions;
export default selectedBatchSlice.reducer;
